<mat-card class="privacyCard">
    <mat-card-header>
        <mat-card-title>Privacy Policy</mat-card-title>
        <!--        <mat-card-subtitle>Last Edited DATE</mat-card-subtitle>-->
    </mat-card-header>
    <mat-card-content>
        <p>To request permanent deletion of your Explain Community account and associated personal data,
            visit the <a routerLink="/account-deletion">account deletion page</a>. You do not need to sign in.</p>
        <div [innerHTML]="this.lastSelectedCommunity?.privacy_policy_text_rendered|| this.lastSelectedCommunity?.privacy_policy"
             class="ck-editorControl"></div>
    </mat-card-content>
</mat-card>
